var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "align-middle" },
    [
      _c("toggle-button", {
        key: _vm.toggleKey,
        attrs: { color: _vm.color, sync: true, labels: _vm.labelsValue },
        on: { change: _vm.fnCallback },
        model: {
          value: _vm.toggleValue,
          callback: function ($$v) {
            _vm.toggleValue = $$v
          },
          expression: "toggleValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }